import { render, staticRenderFns } from "./CourseDataDownload.vue?vue&type=template&id=2bbcb36a&scoped=true&"
import script from "./CourseDataDownload.vue?vue&type=script&lang=js&"
export * from "./CourseDataDownload.vue?vue&type=script&lang=js&"
import style0 from "./CourseDataDownload.vue?vue&type=style&index=0&id=2bbcb36a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbcb36a",
  null
  
)

export default component.exports